import _ from 'lodash';
import DepartmentMappings from './company-content-src/department-mappings';

export const getSlug = ({ name }) => {
  return _.kebabCase(name);
};

export const getDepartmentRelativePath = (department) => {
  return `/careers/${getSlug(department)}`;
};
export const getJobRelativePath = (job) => {
  return `/careers/job/${job.id}`;
};

export const getDepartmentEnabled = (slug) => {
  const department = _.get(DepartmentMappings, slug);
  return department?.enabled;
};
